//import useGlobalStore from "@/stores/global.store";
import { useQuery } from '@tanstack/react-query';
import { GetGroupNameResponse, ListGroupNamesResponse } from '@/types/api/group';
import api from '@/api';

type GroupQueryKey = ['groups', 'name', object];

export function useGroupNamesQuery(params: object) {
  return useQuery<ListGroupNamesResponse, Error, ListGroupNamesResponse, GroupQueryKey>({
    queryKey: ['groups', 'name', params],
    queryFn: () => api.group.getNames(params),
    enabled: Boolean(params),
  });
}
